/**
 * Created by DejanK on 1/9/2017.
 */
import {get, noop, isEqual, isUndefined, omitBy, each} from 'lodash';
import angular from 'angular';

export default ControllerUtils;

ControllerUtils.$inject = ['$state', 'rbDialog', '$q', 'RbAnchorScroll', '$timeout', '$window'];
function ControllerUtils($state, rbDialog, $q, RbAnchorScroll, $timeout, $window){
  const $service = this;

  const defaultHttpErrorHandlers = {
    400: reportAndDisplayGenericErrorPage,
    500: reportAndDisplayGenericErrorPage,
    503: reportAndDisplayGenericErrorPage,
    401: saveVmStateAndRedirectToSignIn,
    403: toForbidden,
    404: toNotFound,
    408: retryOnce,
    other: displayGenericErrorPage
  };

  $service.hasNotChanged = hasNotChanged;
  $service.loadTo = loadTo;
  $service.save = save;
  $service.getParam = getStateParam;
  $service.go = $state.go;
  $service.hasHistoryBack = ()=>{return $window.history.length > 1;};
  $service.goHistoryBack = ()=>{$window.history.back();};
  $service.goToError = goToError;
  $service.error = goToError;
  $service.success = goToSuccess;
  $service.stopEvent = stopEvent;
  $service.scroll = RbAnchorScroll.scroll;
  $service.showDialog = rbDialog.show;
  $service.hideDialog = rbDialog.hide;
  $service.cancelDialog = rbDialog.cancel;
  $service.reload = ()=>{$state.reload()};
  $service.reportAndDisplayGenericErrorPage = reportAndDisplayGenericErrorPage;
  $service.encodeParam = encodeParam;
  $service.encodeCurrentState = encodeCurrentState;
  $service.decodeParam = decodeParam;
  $service.goToEncodedState = goToEncodedState;

  $service.$state = $state;
  $service.rbDialog = rbDialog;
  $service.$q = $q;
  $service.$timeout = $timeout;

  function loadTo(vm, destination, loaderFn, options){
    vm[destination] = 'loading';
    return loaderFn()
      .then((results)=>{
        vm[destination] = results;
        return results;
      }, (error) => {
        vm[destination] = 'error';
        return getHttpErrorHandler(error, vm, options);
      });
  }

  function save(vm, saveFn, options){
    rbDialog.show('working', {locals: {type: get(options, 'workingLabelType')}});
    return saveFn()
      .then(onSuccess, onFailure);

    function onSuccess(results){
      return rbDialog.hide()
        .then(function returnResults(){return results}, noop);
    }

    function onFailure(error){
      return rbDialog.hide()
        .then( function handleError(){
          return getHttpErrorHandler(error, vm, options);
        }, noop)
    }
  }

  function getHttpErrorHandler(error, vm, options){
    const
      errorHandlers = {
        ...defaultHttpErrorHandlers,
        ...get(options, 'errorHandlers')
      },
      handler = errorHandlers[`${error.status}`] || errorHandlers.other;

    // eslint-disable-next-line no-console
    console.error('err', error, error.status, handler);
    return handler(error, vm, options) || $q.reject(error);
  }

  function reportAndDisplayGenericErrorPage(error){

    //console.log(vm);
    //console.log(error, JSON.stringify(error));
    // todo: save to send errors to server;
    goToError('500');
    return $q.reject(error);
  }

  function saveVmStateAndRedirectToSignIn(){
    // todo: save VM state and provide data for redirection back after successful signIn
    $state.go('signIn')
  }

  function toForbidden(){
    goToError('403');
  }

  function toNotFound(){
    goToError('404');
  }

  // eslint-disable-next-line no-unused-vars
  function notifyNotFound(error, vm, options){
    rbDialog.show('error', {
      locals: {
        Error: {
          heading: 'Requested resource',
          title: 'Not Found!',
          message: '',
          ...get(options, 'errorNotification')
        }
      }
    });
  }

  function displayGenericErrorPage(error){
    goToError('500', error);
  }

  function retryOnce(){
    // todo: will see how to implement this. First server should support idempotent POSTs. Redirect to 408 for now
    goToError('408');
  }

  function goToError(errorId, error){
    $state.go('error', {id: errorId, error: error ? b64EncodeUnicode(JSON.stringify(error)) : ''}); // todo: check this
  }

  function goToSuccess(successId, successData){
    const to = {id: successId};
    if(successData) {to.data = btoa(JSON.stringify(successData))}
    $state.go('success', to);
  }

  function stopEvent(event){
    if(event){
      event.stopPropagation();
      event.preventDefault();
    }
  }

  function getStateParam(paramKey){
    return get($state, `params.${paramKey}`);
  }

  function b64EncodeUnicode(str) {
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function(match, p1) {
      return String.fromCharCode(`0x${  p1}`);
    }));
  }

  function hasNotChanged(val1, val2){
    return isEqual(deepOmitBy(val1, isUndefined), deepOmitBy(val2, isUndefined));

    function deepOmitBy(obj, predicate) {
      // basic _.omit on the current object
      const r = omitBy(obj, predicate);

      //transform the children objects
      each(r, function(val, key) {
        if (typeof(val) === 'object')
          r[key] = deepOmitBy(val, predicate);
      });

      return r;
    }
  }

  // eslint-disable-next-line no-unused-vars
  function debugIsEqual(o1, o2){
    if(angular.isArray(o1)){
      return isEqualArray(o1, o2);
    } else if(angular.isObject(o1)) {
      return isEqualObject(o1, o2);
    } else {
      return isEqualValue(o1, o2);
    }

    function isEqualArray(a1, a2){
      if(!angular.isArray(a2)) {
        // console.log('not array', a1, a2);
        return false;
      } else if (a1.length !== a2.length){
        // console.log('arrays not equal in length', a1, a2);
        return false;
      } else {
        for(let i = 0, l = a1.length; i<l; i++){
          const e = isEqual(a1[i], a2[i]);
          if(!e){
            // if(!e) console.log(`array item ${i} not equal`, a1, a2);
            return false;
          }
        }
        return true;
      }
    }

    function isEqualObject(a, b){
      if(!angular.isObject(b)) {
        // console.log('not object', a, b);
        return false;
      } else {
        const o1Keys = Object.keys(a);
        const o2Keys = Object.keys(b);
        if (o1Keys.length !== o2Keys.length){
          // console.log('objects not equal in length', a, b);
          return false;
        } else {
          for(let i = 0, l = o1Keys.length; i<l; i++){
            const e = isEqual(a[o1Keys[i]], b[o1Keys[i]]);
            if(!e){
              // !e && console.log(`Object property ${o1Keys[i]} not equal`, a, b);
              return false;
            }
          }
          return true;
        }
      }
    }

    function isEqualValue(a, b) {
      const e = a === b;
      if(!e){
        // console.log(`${a} not equal to ${b}`);
        return false;
      }
      return true;
    }
  }


  function encodeParam(obj){
    return encodeURIComponent(btoa(JSON.stringify(obj)));
  }

  function encodeCurrentState(){
    return encodeParam({state: $state.current.name, params: $state.params});
  }

  function decodeParam(s){
    return JSON.parse(atob(decodeURIComponent(s)))
  }

  function goToEncodedState(s){
    const savedState = decodeParam(s);
    $state.go(savedState.state, savedState.params);
    return true;
  }

}
